import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statusCode: null,
  grnItems: [],
  rejectItems: [],
  attachments: [],
  origin: "CreateGrn",
  grnDetailsForm: [],
  selectedSupplier: null,
  grnData: null,
  totalGross: 0,
  grnTaxTypes: [],
  taxValues: [],
  totalDiscount: 0,
};

const grnSlice = createSlice({
  name: "grn",
  initialState,
  reducers: {
    setGrnData(state, action) {
      return { ...state, ...action.payload };
    },
    clearGrnData: () => initialState, //  FIXED
  },
});

export const { setGrnData, clearGrnData } = grnSlice.actions;
export default grnSlice.reducer;
